module.exports = __webpack_public_path__ + "static/media/WCRO.7448e300.svg";